import React, { useContext } from "react"
import { WebpContext } from "./webp-check"
import { NO_WEBP } from "./webp-check"

export const Img = (props) => {
  const noWebpSupport = useContext(WebpContext) 
  const src = !noWebpSupport ? props.src : `${props.src}?${NO_WEBP}`
  const srcSet = !noWebpSupport
    ? props.srcSet
    : (props.srcSet || "").replace(
        /\.(jpg|jpeg|png) /gi,
        (_, extension) => `.${extension}?${NO_WEBP} `
      ) || undefined
  return <img {...props} alt={props.alt} src={src} srcSet={srcSet} />
}

